// pages/explore.tsx
import { FC, useState } from 'react';
import ExplorationQueue from '../components/ExplorationQueue';
import { useAuth } from '../contexts/AuthContext';
import SearchPage from './search';

const ExplorePage: FC = () => {
  const { isAuthenticated, login } = useAuth();
  const [queueRefreshKey, setQueueRefreshKey] = useState(0);

  if (!isAuthenticated) {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <h1 className="text-3xl font-bold mb-8 text-center">Artist Exploration</h1>
          <p className="text-lg mb-8 text-center">
            Please login to manage your artist exploration queue.
          </p>
          <button
              onClick={login}
              className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full text-lg transition duration-300"
          >
            Login with Spotify
          </button>
        </div>
    );
  }

  return (
      <div className="page-container">
        <SearchPage embedded onArtistAdded={() => setQueueRefreshKey(key => key + 1)} />
        <ExplorationQueue refreshKey={queueRefreshKey} />
      </div>
  );
};

export default ExplorePage;
